import { createReducer } from "reduxsauce"
import actionCreator from "helpers/actionCreator"
import { memoizedTrackingValues } from "modules/data-cloud/helpers"

const DEFAULT_STATE = {}

export const { Types, Creators } = actionCreator("ompnt/modules/data-cloud/", {
  searchQuery: {
    props: ["query"],
    track: true,
    trackType: "datacloud-browse-search",
    trackPayload: ({ query }) => ({ query }),
  },
  searchFilter: {
    props: ["filter"],
    track: true,
    trackType: "datacloud-browse-filter",
    trackPayload: ({ filter }) => ({ filter: memoizedTrackingValues(filter) }),
  },
  contactUs: {
    props: ["dataset"],
    track: true,
    trackType: "datacloud-contact-us",
    trackPayload: ({ dataset }) => ({ dataset }),
  },
  reactivate: {
    props: ["dataset"],
    track: true,
    trackType: "datacloud-reactivate",
    trackPayload: ({ dataset }) => ({ dataset }),
  },
  notFound: {
    props: ["query", "filter"],
    track: true,
    trackType: "datacloud-not-found",
    trackPayload: ({ query }) => ({ query }),
  },
})

export default createReducer(DEFAULT_STATE, {

})
